/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class SharedComponentKey {
  static readonly AUTO_COMPLETE_INPUT = 'shared/component/auto-complete-input';
  static readonly MONTH_SELECT = 'shared/component/month-select';
  static readonly CUSTOM_TABLE = 'shared/component/custom-table';
  static readonly RESIZE_TEXT_AREA = 'shared/component/resize-text-area';
  static readonly USER_DETAIL = 'shared/component/user-detail';
  static readonly EMPLOYEE_PERMISSIONS_DIALOG = 'shared/component/employee-permissions-dialog';
  static readonly PROJECT_PERMISSIONS_DIALOG = 'shared/component/project-permissions-dialog';
  static readonly CURRENT_SUBSCRIPTION = 'shared/component/current-subscription';
  static readonly MANAGE_SUBSCRIPTION = 'shared/component/manage-subscription';
  static readonly COMPANY_DETAIL = 'shared/component/company-detail';
  static readonly PAYMENT_METHODS = 'shared/component/payment-methods';
  static readonly TAG_TABLE = 'shared/component/tag-table';
}
